import { FunctionComponent, ReactNode } from "react";

export type InputHintProps = {
  children?: ReactNode | ReactNode[];
};

export const InputHint: FunctionComponent<InputHintProps> = ({ children }: InputHintProps) => {
  return <div className="text-sm text-gray-500">{children}</div>;
};
